export type PageLogicOperator =
    | "equals"
    | "not_equals"
    | "includes"
    | "greater_than"
    | "greater_than_or_equals"
    | "less_than"
    | "less_than_or_equals";

export const NUMERIC_PAGE_LOGIC_OPERATORS: PageLogicOperator[] = [
    "greater_than",
    "greater_than_or_equals",
    "less_than",
    "less_than_or_equals",
];

export interface PageLogicCondition {
    input_id: string;
    operator: PageLogicOperator;
    value: string | number | boolean;
}

export type PageLogicAction = { action: "next" } | { action: "jump"; target_page_id: string } | { action: "end" };

export interface PageLogicRule {
    when: PageLogicCondition;
    then: Exclude<PageLogicAction, { action: "next" }>;
}

export interface PageLogic {
    rules: PageLogicRule[];
    fallback: PageLogicAction;
}

export type PageLogicResolution = { kind: "page"; page_id: string } | { kind: "end" };

export interface PageLogicPageRef {
    page_id: string;
    page_index: number;
    page_logic?: PageLogic | null;
}

export interface FormAnswerMap {
    [inputId: string]: string | number | boolean | string[] | null | undefined;
}
